<template>
	<div class='menu'>
		<MenuButton 
			v-for='(button, index) in buttons' 
			v-bind:key='button.id' 
			v-bind:index='index'
			v-bind:button='button'
			v-on:switch='switchPage'
		/>
	</div>
</template>

<script>
import MenuButton from '@/components/MenuButton.vue'

export default {
	name: 'AppMenu',
	components: {
		MenuButton
	},
	data: function() {
		return {
			buttons: [
				{
					path: '/list',
					isActive: false
				},
				{
					path: '\/',
					isActive: false
				},
				{
					path: '/speaker',
					isActive: false
				}
			]
		}
	},
	methods: {
		switchPage: function(index) {
			this.buttons = this.buttons.map(function(item, i) {
				return {
					path: item.path,
					isActive: i == index ? true : false
				}
			});
		}
	},
	beforeMount: function() {
		switch(window.location.pathname) {
			case '\/': {
				this.buttons[1].isActive = true;
				break;
			}
			case '\/list': {
				this.buttons[0].isActive = true;
				break;
			}
			case '\/speaker': {
				this.buttons[2].isActive = true;
				break;
			}
		}
	}
}
</script>

<style lang='less'>
.menu {
	width: 170px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: fixed;
	bottom: 9px;
	left: calc(50% - 85px);
}
</style>